module.exports = __webpack_public_path__ + "static/media/TN-Men-Pants-v2.0.533f9b5f.svg";